export const EMPOWERMENT_ZONE_TYPES = {
  NONE: "none",
  EMPOWERMENT: "empowerment",
  RURAL: "rural",
};

export const EMPOWERMENT_FILTER_VALUES = {
  ALL: "all",
  EMPOWERMENT: EMPOWERMENT_ZONE_TYPES.EMPOWERMENT,
  RURAL: EMPOWERMENT_ZONE_TYPES.RURAL,
};

export const EMPOWERMENT_FILTERS = [
  { value: EMPOWERMENT_FILTER_VALUES.ALL, label: "All Businesses" },
  { value: EMPOWERMENT_FILTER_VALUES.EMPOWERMENT, label: "Federal Empowerment Zones" },
  { value: EMPOWERMENT_FILTER_VALUES.RURAL, label: "Rural Renewal Counties" },
];

const FLATTEN_KEYS = ["zone", "zoneName", "label", "name", "description"];

const flattenZoneValues = (input) => {
  if (input === undefined || input === null) return [];
  if (Array.isArray(input)) {
    return input.reduce(
      (acc, value) => acc.concat(flattenZoneValues(value)),
      []
    );
  }
  return [input];
};

const normalizeZoneLabel = (value) => {
  if (value === undefined || value === null) return "";
  if (typeof value === "string") return value.trim();
  if (typeof value === "number") return String(value).trim();
  if (typeof value === "object") {
    for (const key of FLATTEN_KEYS) {
      const altKey = key[0].toUpperCase() + key.slice(1);
      const resolved = value[key] ?? value[altKey];
      if (resolved) {
        return String(resolved).trim();
      }
    }
  }
  return "";
};

const splitCombinedLabels = (label) => {
  if (!label) return [];
  return String(label)
    .split(/[,/|;]+/)
    .map((segment) => segment.trim())
    .filter(Boolean);
};

const determineCategoryFromLabel = (label) => {
  if (!label) return EMPOWERMENT_ZONE_TYPES.NONE;
  const normalized = label.trim().toLowerCase();
  if (!normalized || normalized === "none") return EMPOWERMENT_ZONE_TYPES.NONE;
  if (normalized.includes("rural renewal")) return EMPOWERMENT_ZONE_TYPES.RURAL;
  if (normalized.includes("empowerment"))
    return EMPOWERMENT_ZONE_TYPES.EMPOWERMENT;
  return EMPOWERMENT_ZONE_TYPES.NONE;
};

export const getEmpowermentZoneLabels = (input) => {
  const labels = [];
  flattenZoneValues(input).forEach((value) => {
    const label = normalizeZoneLabel(value);
    splitCombinedLabels(label).forEach((entry) => {
      if (
        entry &&
        entry.toLowerCase() !== "none" &&
        !labels.some((existing) => existing.toLowerCase() === entry.toLowerCase())
      ) {
        labels.push(entry);
      }
    });
  });
  return labels;
};

export const getEmpowermentZoneCategories = (input) => {
  const categories = [];
  getEmpowermentZoneLabels(input).forEach((label) => {
    const category = determineCategoryFromLabel(label);
    if (
      category !== EMPOWERMENT_ZONE_TYPES.NONE &&
      !categories.includes(category)
    ) {
      categories.push(category);
    }
  });
  return categories;
};

export const getEmpowermentZoneCategory = (input) => {
  const categories = getEmpowermentZoneCategories(input);
  if (categories.includes(EMPOWERMENT_ZONE_TYPES.EMPOWERMENT)) {
    return EMPOWERMENT_ZONE_TYPES.EMPOWERMENT;
  }
  if (categories.includes(EMPOWERMENT_ZONE_TYPES.RURAL)) {
    return EMPOWERMENT_ZONE_TYPES.RURAL;
  }
  return EMPOWERMENT_ZONE_TYPES.NONE;
};

export const getEmpowermentZoneLabel = (input) =>
  getEmpowermentZoneLabels(input).join(", ");

export const EMPOWERMENT_PIN_COLORS = {
  [EMPOWERMENT_ZONE_TYPES.NONE]: {
    background: "#2434D0",
    borderColor: "#05149c",
    glyphColor: "#ffffff",
  },
  [EMPOWERMENT_ZONE_TYPES.EMPOWERMENT]: {
    background: "#1a9c4b",
    borderColor: "#0f6633",
    glyphColor: "#ffffff",
  },
  [EMPOWERMENT_ZONE_TYPES.RURAL]: {
    background: "#f5e6a3",
    borderColor: "#c4a645",
    glyphColor: "#4d3900",
  },
};
